module.exports = __webpack_public_path__ + "media/images/front/about/calendar-006fdbcb310a4a8d942fea8f71951e3a.jpg";